/**
 * Labstep
 *
 * @module components/ExperimentWorkflow/EmptyState
 * @desc Empty state for experiment workflows
 */

import { ExperimentWorkflowActionCreateMenu } from 'labstep-web/components/ExperimentWorkflow/Action/CreateMenu';
import { CardEmptyState } from 'labstep-web/core/Card/EmptyState';
import { ExperimentWorkflow } from 'labstep-web/models/experiment-workflow.model';
import { ProtocolCollection } from 'labstep-web/models/protocol-collection.model';
import type React from 'react';
import type { ExperimentWorkflowEmptyStateProps } from './types';

const explanation = `
Use ${ExperimentWorkflow.getHumanReadableEntityName(
  true,
)} to document your activities in the lab. Keep all your results and data linked to the ${ProtocolCollection.getHumanReadableEntityName(
  true,
)} that produced them. Track the specific inventory items and amounts used in each ${ProtocolCollection.getHumanReadableEntityName()}.
`;

export const ExperimentWorkflowEmptyState: React.FC<
  ExperimentWorkflowEmptyStateProps
> = (props) => (
  <CardEmptyState
    title={`No ${ExperimentWorkflow.getHumanReadableEntityName(
      true,
      true,
    )}`}
    explanation={explanation}
    src="/img/empty-state/experiments.svg"
    action={<ExperimentWorkflowActionCreateMenu />}
    {...props}
  />
);
